import React, { useState } from "react";
import VistaConciliacionBancaria from "./VistaConciliacionBancaria";
import VistaConciliacion from "./VistaConciliacion";
import VistaSeguimientoCasos from "./VistaSeguimientoCasos";

// Modulo "Conciliacion" (solo Administrador), con tres pestañas:
//   - Bancos: lo que Financieros revisa (cobrado, depositado y registrado por plantel, y los casos de cada plantel).
//   - Seguimiento de casos: lo que hizo cada plantel con los casos publicados.
//   - Pagos en línea: la comparacion de siempre contra Payworks 2, que entrega los scripts de correccion (Sistemas).
const PESTANAS = [
  { id: "bancos", titulo: "Bancos (TPV, en línea y ventanilla)" },
  { id: "seguimiento", titulo: "Seguimiento de casos" },
  { id: "linea", titulo: "Pagos en línea: scripts de corrección" },
];

const ModuloConciliacion = ({ catalogoPlanteles = [], catalogoConceptos = [], pestanaInicial = "bancos" }) => {
  const [pestana, setPestana] = useState(pestanaInicial);
  return (
    <div>
      <div role="tablist" aria-label="Conciliación" style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "10px" }}>
        {PESTANAS.map((p) => (
          <button key={p.id} role="tab" aria-selected={pestana === p.id} onClick={() => setPestana(p.id)} className="btn-select"
            style={{ border: "1px solid #003b5c", padding: "8px 14px", backgroundColor: pestana === p.id ? "#003b5c" : "#fff", color: pestana === p.id ? "#fff" : "#003b5c" }}>
            {p.titulo}
          </button>
        ))}
      </div>
      {pestana === "bancos" && <VistaConciliacionBancaria catalogoPlanteles={catalogoPlanteles} />}
      {pestana === "seguimiento" && <VistaSeguimientoCasos catalogoPlanteles={catalogoPlanteles} />}
      {pestana === "linea" && <VistaConciliacion catalogoPlanteles={catalogoPlanteles} catalogoConceptos={catalogoConceptos} />}
    </div>
  );
};

export default ModuloConciliacion;
